<p-toast position="top-right"></p-toast>
<div class="reset-wrapper">
  <div class="reset-card">
    <!-- icon -->
    <div class="icon-circle">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
        <path
          d="M17 9H7C5.89543 9 5 9.89543 5 11V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V11C19 9.89543 18.1046 9 17 9Z"
          stroke="#6C3EF4"
          stroke-width="1.8"
        />
        <path
          d="M8 9V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V9"
          stroke="#6C3EF4"
          stroke-width="1.8"
        />
      </svg>
    </div>

    <h2>Forgot Password?</h2>

    <p class="subtitle">Enter your email and we'll help you reset your password</p>

    <!-- new password -->
    <div class="form-group">
      <label>New Password <span class="np-required">*</span></label>
      <input type="password" [(ngModel)]="newPassword" />
    </div>

    <!-- confirm -->
    <div class="form-group">
      <label>Confirm Password <span class="np-required">*</span></label>
      <input type="password" [(ngModel)]="confirmPassword" />
    </div>

    <button
      class="update-btn"
      (click)="updatePassword()"
      [disabled]="!newPassword || !confirmPassword"
    >
      Update Password
    </button>
  </div>
</div>
